import { useEffect, useRef, useState } from 'react';

import { second } from '@utils/milliseconds';
import { Timeout } from '@utils/types';

export function useMinimumDelay<T>(incomingState: T, minDuration: number = second) {
  const [state, setState] = useState<T | null>(null);

  const startRef = useRef(0);
  const timerRef = useRef<Timeout>();

  useEffect(() => {
    if (incomingState) {
      clearTimeout(timerRef.current);
      startRef.current = Date.now();
      setState(incomingState);
    } else {
      const elapsed = Date.now() - startRef.current;
      const delay = Math.max(minDuration - elapsed, 0);
      timerRef.current = setTimeout(() => setState(null), delay);
    }

    return () => clearTimeout(timerRef.current);
  }, [incomingState, minDuration]);
  return state;
}
